import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import compact from 'lodash/compact';
import RoomType from './RoomType';
import { Box } from '@qga/roo-ui/components';
import { getAllAvailableOffers } from 'store/exclusiveOffer/exclusiveOfferSelectors';
import { minBy, keys, sortBy, partition, some } from 'lodash';

const RoomTypeList = ({ ...rest }) => {
  return (
    <Fragment>
      <Box overflow={['hidden', 'inherit']} backgroundColor={'greys.porcelain'}>
        <RoomTypes {...rest} backgroundColor={'greys.porcelain'} />
      </Box>
    </Fragment>
  );
};

const RoomTypes = ({ roomTypes = [], hasQuery }) => {
  const availableOffers = useSelector(getAllAvailableOffers);

  const [available, unavailable] = partition(roomTypes, (roomType) =>
    some(roomType.exclusiveOffers, (exclusiveOffer) => keys(availableOffers).includes(exclusiveOffer?.id)),
  );

  const sortedAvailable = sortBy(available, (roomType) => {
    const cheapest = minBy(roomType.exclusiveOffers, (exclusiveOffer) => {
      const offer = availableOffers[exclusiveOffer.id];
      return offer && parseInt(offer.charges.total.amount);
    });
    return cheapest && parseInt(availableOffers[cheapest.id].charges.total.amount);
  });

  const sortedUnavailable = sortBy(unavailable, (roomType) => {
    const cheapest = minBy(roomType.exclusiveOffers, (exclusiveOffer) => {
      return parseInt(exclusiveOffer.offerTotal.amount);
    });
    return cheapest && parseInt(cheapest.offerTotal.amount);
  });

  const sortedRoomTypes = [...sortedAvailable, ...sortedUnavailable];

  return compact(sortedRoomTypes.map((roomType) => <RoomType roomType={roomType} hasQuery={hasQuery} key={roomType.id} />));
};

RoomTypes.defaultProps = {
  roomTypes: [],
};
RoomTypes.displayName = 'RoomTypes';
RoomTypes.propTypes = {
  hasQuery: PropTypes.bool.isRequired,
  roomTypes: PropTypes.array,
};

export default RoomTypeList;
